module.exports = __webpack_public_path__ + "img/w.2e3f3799.png";